export default __webpack_public_path__ + "static/media/electricity.e1c122e5.svg";